// Initialize compare list from local storage
let compareList = JSON.parse(localStorage.getItem('compareList')) || [];

// Log initial state for debugging
console.log('Initial compareList:', compareList);

// Helper function to decode HTML entities
function decodeHtml(html) {
  try {
    if (typeof html !== 'string') {
      return '';
    }
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    const decoded = txt.value;
    return decoded;
  } catch (error) {
    return '';
  }
}

// Helper function to parse HTML table and extract key-value pairs
function parseSpecsTable(html) {
  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const rows = doc.querySelectorAll('tr.spec-wrap');
    const specs = Array.from(rows).map(row => {
      const label = row.querySelector('.spec-label')?.textContent.trim() || '';
      const value = row.querySelector('.spec-value')?.textContent.trim() || '';
      return { label, value };
    }).filter(spec => spec.label && spec.value);
    console.log('Parsed specs:', specs);
    return specs;
  } catch (error) {
    console.error('Error parsing specs table:', error);
    return [];
  }
}

// Helper function to show modal popup
// Helper function to show modal popup
function showModal(message, isError = false) {
  try {
    // Remove existing modal if any
    const existingModal = document.querySelector('.compare-modal');
    if (existingModal) existingModal.remove();

    // Calculate the number of products added and remaining slots
    const productsAdded = compareList.length;
    const maxProducts = 5;
    const remainingSlots = maxProducts - productsAdded;

    // Append the product count information to the message (only for non-error messages)
    const enhancedMessage = isError
      ? message
      : `${message} (${productsAdded} of ${maxProducts} products added. You can add ${remainingSlots} more.)`;

    // Create modal elements
    const modal = document.createElement('div');
    modal.className = `compare-modal ${isError ? 'error' : ''}`;
    modal.innerHTML = `
      <div class="compare-modal__content">
        <div class="icon-wrap">
          <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.6313 11.8125H19.6875V13.125H19.4619C19.3252 13.5146 19.1338 13.8701 18.8877 14.1914C18.6416 14.5127 18.3511 14.7896 18.0161 15.022C17.6812 15.2544 17.3257 15.4321 16.9497 15.5552C16.5737 15.6782 16.1738 15.7432 15.75 15.75C15.3398 15.75 14.9399 15.6885 14.5503 15.5654C14.1606 15.4424 13.8018 15.2646 13.4736 15.0322C13.1455 14.7998 12.8584 14.5229 12.6123 14.2017C12.3662 13.8804 12.1748 13.5215 12.0381 13.125H11.8125V11.8125H12.8687L14.7861 6.07031L10.5 4.64502V17.083C11.6553 17.1582 12.7388 17.4146 13.7505 17.8521C14.7622 18.2896 15.6919 18.9014 16.5396 19.6875H18.375V21H1.3125V19.6875H3.14795C3.98877 18.9082 4.91846 18.2998 5.93701 17.8623C6.95557 17.4248 8.03906 17.165 9.1875 17.083V4.2041L5.14746 2.86084L6.81885 7.875H7.875V9.1875H7.64941C7.5127 9.57715 7.32129 9.93262 7.0752 10.2539C6.8291 10.5752 6.53857 10.8521 6.20361 11.0845C5.86865 11.3169 5.51318 11.4946 5.13721 11.6177C4.76123 11.7407 4.36133 11.8057 3.9375 11.8125C3.52734 11.8125 3.12744 11.751 2.73779 11.6279C2.34814 11.5049 1.98926 11.3271 1.66113 11.0947C1.33301 10.8623 1.0459 10.5854 0.799805 10.2642C0.553711 9.94287 0.362305 9.58398 0.225586 9.1875H0V7.875H1.05615L2.97363 2.13281L0.287109 1.24072L0.70752 0L9.1875 2.81982V0H10.5V3.26074L19.3901 6.21387L18.9697 7.46484L16.9497 6.78809L18.6313 11.8125ZM6.21387 9.1875H1.66113C1.90039 9.59766 2.22168 9.91895 2.625 10.1514C3.02832 10.3838 3.46582 10.5 3.9375 10.5C4.40918 10.5 4.84668 10.3838 5.25 10.1514C5.65332 9.91895 5.97461 9.59766 6.21387 9.1875ZM5.43457 7.875L3.9375 3.38379L2.44043 7.875H5.43457ZM9.84375 18.375C9.03711 18.375 8.24756 18.4844 7.4751 18.7031C6.70264 18.9219 5.97461 19.25 5.29102 19.6875H14.3965C13.7197 19.2568 12.9917 18.9321 12.2124 18.7134C11.4331 18.4946 10.6436 18.3818 9.84375 18.375ZM15.75 7.32129L14.2529 11.8125H17.2471L15.75 7.32129ZM18.0264 13.125H13.4736C13.7129 13.5352 14.0342 13.8564 14.4375 14.0889C14.8408 14.3213 15.2783 14.4375 15.75 14.4375C16.2217 14.4375 16.6592 14.3213 17.0625 14.0889C17.4658 13.8564 17.7871 13.5352 18.0264 13.125Z" fill="black"></path>
          </svg>
        </div>
        <h4 class="compare-title">Compare Product</h4>
        <p class="compare-modal__message">${enhancedMessage}</p>
        <div class="button-row">
          <a href="/pages/compare-products" class="btn">View Page</a>
          <button class="compare-modal__close btn">Close</button>
        </div>
      </div>
    `;
    document.body.appendChild(modal);

    // Show modal
    modal.style.display = 'flex';

    // Close modal on button click
    const closeButton = modal.querySelector('.compare-modal__close');
    closeButton.addEventListener('click', () => {
      modal.remove();
    });

    // Close modal on outside click
    modal.addEventListener('click', (event) => {
      if (event.target === modal) {
        modal.remove();
      }
    });

    // Auto-close after 3 seconds
    setTimeout(() => modal.remove(), 8000000);
  } catch (error) {
    alert(message); // Fallback to alert if modal fails
  }
}
// Debounce utility to limit function calls
function debounce(func, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

// Function to update comparison count
function updateCompareCount() {
  try {
    const countElements = document.querySelectorAll('.compare-count');
    countElements.forEach(element => {
      element.textContent = compareList.length;
    });
  } catch (error) {
    console.error('Error in updateCompareCount:', error);
  }
}

// Function to add product to comparison
function addToCompare(product) {
  try {
    if (!product.id) {
      showModal('Error: Invalid product data.', true);
      return;
    }

    if (compareList.some(item => String(item.id) === String(product.id))) {
      console.log('Duplicate product ID:', product.id);
      showModal('This product is already in your comparison list.', true);
      return;
    }

    if (compareList.length >= 4) {
      showModal('You can compare up to 5 products. Remove one to add more.', true);
      return;
    }

    compareList.push(product);
    localStorage.setItem('compareList', JSON.stringify(compareList));
    console.log('Added product:', product);
    showModal('Product added to comparison!');
    updateCompareCount();
  } catch (error) {
    console.error('Error in addToCompare:', error);
    showModal('Error adding product to comparison.', true);
  }
}

function setDynamicSpecHeights() {
  try {
    const grid = document.getElementById('compareGrid');
    if (!grid) return;

    const productCards = grid.querySelectorAll('.product-grid__item');
    if (productCards.length === 0) return;

    // Find the maximum number of specs across all cards
    const maxSpecs = Math.max(...Array.from(productCards).map(card => card.querySelectorAll('.product-spec').length));

    // For each row position
    for (let index = 0; index < maxSpecs; index++) {
      // Get all .product-spec elements at this index
      const rows = Array.from(productCards).map(card => card.querySelectorAll('.product-spec')[index]).filter(Boolean);
      if (rows.length === 0) continue;

      // Temporarily reset heights to measure natural height
      rows.forEach(row => {
        row.style.height = 'auto';
        row.style.overflow = 'visible';
      });

      // Calculate the maximum natural height for this row position
      const maxHeight = Math.max(...rows.map(row => row.getBoundingClientRect().height));

      // Apply the maximum height to all rows in this position
      rows.forEach(row => {
        row.style.height = `${maxHeight}px`;
        row.style.overflow = 'hidden';
        row.style.textOverflow = 'ellipsis';
        // Optional: Add title attribute for tooltip
        const label = row.querySelector('strong')?.textContent || '';
        const value = row.querySelector('.value')?.textContent || '';
        row.setAttribute('title', `${label}: ${value}`);
      });
    }
  } catch (error) {
    console.error('Error in setDynamicSpecHeights:', error);
  }
}

// Function to populate comparison grid
function populateCompareGrid() {
  const grid = document.getElementById('compareGrid');
  if (!grid) {
    console.log('Not on comparison page, skipping grid population.');
    return;
  }

  grid.innerHTML = '';

  if (compareList.length === 0) {
    grid.innerHTML = '<li class="product-grid__item"><h5>No products to compare yet.</h5></li>';
  } else {
    compareList.forEach(product => {
      if (!product.title || !product.price || !product.image || !product.variant_id || !product.url) {
        console.error('Invalid product data in compareList:', product);
        return;
      }

      // Log specs for debugging
      console.log('Product specs for ID', product.id, ':', product.specs);

      // Decode and parse specs
      const decodedSpecs = typeof product.specs === 'string' && product.specs.trim() !== ''
        ? decodeHtml(product.specs)
        : '';
      const specsArray = decodedSpecs ? parseSpecsTable(decodedSpecs) : [];
      const specsContent = specsArray.length > 0
        ? specsArray.map(spec => `<span class="product-spec"><strong>${spec.label}:</strong><span class="value">${spec.value} </span></span>`).join('')
        : '<span class="product-spec">No specifications available</span>';

      // Log rendered specs
      console.log('Rendered specs for ID', product.id, ':', specsContent);

      const productCard = document.createElement('li');
      productCard.className = 'product-grid__item product-grid__item-column';
      productCard.setAttribute('data-product-id', product.id);

      // Render product card with specs as spans and product URL link
      productCard.innerHTML = `
        <product-card class="product-card" data-product-id="${product.id}">
          <div class="
          product-card__content
          layout-panel-flex
          layout-panel-flex--column
          product-grid__card
          spacing-style
          border-style
          gap-style
          
        ">
          <a class="product-card-link" href="${product.url}" class="product-link" title="${product.title || 'Product'}"></a>
         <div class="product-info-group">
          <div
            style="--border-width: 1px; --border-style: none; --border-color: rgba(fromvar(--color-border) r g b / 1.0); --border-radius:0px;  -padding-block-start: 0px;--padding-block-end: 0px;--padding-inline-start: 0px;--padding-inline-end: 0px; --gallery-aspect-ratio:1;"
            class="card-gallery spacing-style border-style">

            <div class="product-media-container media-fit product-media-container--image">
              <button class="remove-compare" data-id="${product.id}">&times;</button>
              <div class="product-media product-media-padding">
                <img src="${product.image}" alt="${product.title || 'Product'}" width="360" height="360" loading="lazy"  onerror="this.src='https://via.placeholder.com/360';">
                <!-- <button class="add-to-cart btn" data-variant-id="${product.variant_id}">Add to Cart</button> -->
              </div>
            </div>
          </div>
          <div class="section__padding sku-block">
            <span class="product-sku f15 bold">
              ${product.partNumber ? `<span class="product-sku"><span class="sku-label">Part Number:</span>
                ${product.partNumber}</span>` : ''}
              <span>
          </div>
          <div class="spacing-style product-title">
            ${product.title}
          </div>
 
        </div>
        <div class="product-spec-group">
          <h4 class="spec-heading">Specifications </h4>
          <div class="product-card__specs">
            <div class="product-spec-table">${specsContent}</div>
          </div>
        </div>
        </div>
        </product-card>
      `;
      grid.appendChild(productCard);
    });
  }
    setDynamicSpecHeights();

  // Add event listener for card buttons using event delegation
  grid.removeEventListener('click', handleGridClick);
  grid.addEventListener('click', handleGridClick);
}

// Function to handle clicks on remove and add-to-cart buttons
function handleGridClick(event) {
  try {
    if (event.target.classList.contains('remove-compare')) {
      const id = event.target.dataset.id;
      compareList = compareList.filter(item => String(item.id) !== String(id));
      localStorage.setItem('compareList', JSON.stringify(compareList));
      populateCompareGrid();
      updateCompareCount();
    } else if (event.target.classList.contains('add-to-cart')) {
      const variantId = event.target.dataset.variantId;
      console.log('Adding to cart, variant ID:', variantId);
      addToCart(variantId, event.target);
    }
  } catch (error) {
    console.error('Error in handleGridClick:', error);
  }
}

async function addToCart(variantId, button) {
  try {
    button.disabled = true;
    button.textContent = 'Adding...';

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
      }),
    });

    if (!response.ok) {
      throw new Error(`Failed to add to cart: ${response.statusText}`);
    }

    const result = await response.json();
    console.log('Added to cart:', result);
    showModal('Product added to cart!');
    await updateCartCount();
    openCartDrawer();
  } catch (error) {
    console.error('Error adding to cart:', error);
    showModal('Error adding product to cart. Please try again.', true);
  } finally {
    button.disabled = false;
    button.textContent = 'Add to Cart';
  }
}

// Function to update cart count
async function updateCartCount() {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    const cartCountElements = document.querySelectorAll('.cart-count, .header__cart-count, .cart__item-count');
    cartCountElements.forEach(element => {
      element.textContent = cart.item_count;
    });
    console.log('Updated cart count:', cart.item_count);

    if (typeof window.theme?.cart?.update === 'function') {
      window.theme.cart.update();
      console.log('Triggered theme.cart.update');
    }
  } catch (error) {
    console.error('Error updating cart count:', error);
  }
}

// Function to open cart drawer
function openCartDrawer() {
  try {
    if (typeof window.theme?.cart?.open === 'function') {
      window.theme.cart.open();
      console.log('Opened cart drawer via theme.cart.open');
      return;
    }

    const cartDrawer = document.querySelector('.cart-drawer, .ajax-cart, .drawer--cart');
    if (cartDrawer) {
      cartDrawer.classList.add('is-open');
      console.log('Opened cart drawer via class toggle');
    } else {
      console.warn('Cart drawer element not found');
    }

    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: null } }));
  } catch (error) {
    console.error('Error opening cart drawer:', error);
  }
}

// Function to clear comparison list
function clearCompareList() {
  try {
    compareList = [];
    localStorage.removeItem('compareList');
    populateCompareGrid();
    updateCompareCount();
    console.log('Comparison list cleared.');
  } catch (error) {
    console.error('Error in clearCompareList:', error);
  }
}

// Initialize comparison functionality (debounced to prevent excessive calls)
const initializeCompare = debounce(() => {
  try {
    console.log('Initializing compare functionality');
    updateCompareCount();

    document.querySelectorAll('.add-to-compare').forEach(button => {
      button.removeEventListener('click', handleAddToCompare);
      button.addEventListener('click', handleAddToCompare);
    });

    const clearButton = document.getElementById('clearCompare');
    if (clearButton) {
      clearButton.removeEventListener('click', clearCompareList);
      clearButton.addEventListener('click', clearCompareList);
    }

    populateCompareGrid();
  } catch (error) {
    console.error('Error in initializeCompare:', error);
  }
}, 100);

// Handle add to compare click
function handleAddToCompare(event) {
  try {
    const product = JSON.parse(event.currentTarget.dataset.product);
    console.log('Parsed product:', product);
    addToCompare(product);
  } catch (error) {
    console.error('Error parsing product data:', error, event.currentTarget.dataset.product);
    showModal('Error adding product to comparison.', true);
  }
}

// Run initialization on page load
document.addEventListener('DOMContentLoaded', () => {
  console.log('DOMContentLoaded: Initializing compare');
  initializeCompare();
});

// Handle dynamic navigation
document.addEventListener('shopify:section:load', () => {
  console.log('shopify:section:load: Re-initializing compare');
  initializeCompare();
});
document.addEventListener('shopify:block:select', () => {
  console.log('shopify:block:select: Re-initializing compare');
  initializeCompare();
});
window.addEventListener('popstate', () => {
  console.log('popstate: Re-initializing compare');
  initializeCompare();
});